export default __webpack_public_path__ + "static/media/checkbox-checked.19c172d3.svg";